import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { NotificationService } from "src/helpers/notifications";
import { errorResponsesTrns } from "src/translate/responses";
import { IResponseWithPagination } from "src/@types/api";
import { IClone } from "src/@types/clones";

export const CLONES_SLICE_NAME = "clones";
export const ITEMS_PER_PAGE = 10;

interface Params {
  filters: string;
  page?: number;
}

export const getClonesAsync = createAsyncThunk(
  `${CLONES_SLICE_NAME}/fetchClones`,
  async ({ filters }: Params, { rejectWithValue }) => {
    try {
      const filtersQueryStr = filters ? filters : "page=1";

      const { data } = await instance.get<IResponseWithPagination<IClone>>(
        `/clones/?${filtersQueryStr}&page_size=${ITEMS_PER_PAGE}`
      );

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      NotificationService.error(errorText || errorResponsesTrns.clones);

      return rejectWithValue(errorText);
    }
  }
);

export const getTrandingClonesAsync = createAsyncThunk(
  `${CLONES_SLICE_NAME}/fetchTrandingClones`,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<IResponseWithPagination<IClone>>(
        `/clones/tranding-clones/`
      );

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      NotificationService.error(errorText || errorResponsesTrns.default);

      return rejectWithValue(errorText);
    }
  }
);
